import { useCallback, useContext } from "react";
import { AuthContext, fp } from "../App";
import Constants from "../utils/Constants";
import { useFetch } from "../hooks/useFetch";

const apiBaseUrl = Constants.SERVER_URL;

const useShipmentOrder = () => {
  const { authState } = useContext(AuthContext);
  const { send } = useFetch();

  const findAll = useCallback(
    async (query) => {
      const url = apiBaseUrl + "/wapi/shipmentOrders?id=" + query.id;

      const config = {
        method: "get",
        headers: {
          Authorization: "Bearer " + authState.token,
          "Content-Type": "application/json",
          FpId: (await fp).visitorId,
        },
      };

      return await send(url, config);
    },
    [authState.token, send]
  );

  const findOne = useCallback(
    async (id) => {
      const url = apiBaseUrl + "/wapi/shipmentOrders/" + id;

      const config = {
        method: "get",
        headers: {
          Authorization: "Bearer " + authState.token,
          "Content-Type": "application/json",
          FpId: (await fp).visitorId,
        },
      };

      return await send(url, config);
    },
    [authState.token, send]
  );

  const create = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: {
          Authorization: "Bearer " + authState.token,
          "Content-Type": "application/json",
          FpId: (await fp).visitorId,
        },
        body: JSON.stringify(params),
      };

      return await send(apiBaseUrl + "/wapi/shipmentOrders", config);
    },
    [authState.token, send]
  );

  const update = useCallback(
    async (id, params) => {
      const config = {
        method: "post",
        headers: {
          Authorization: "Bearer " + authState.token,
          "Content-Type": "application/json",
          FpId: (await fp).visitorId,
        },
        body: JSON.stringify(params),
      };

      return await send(apiBaseUrl + "/wapi/shipmentOrders/" + id, config);
    },
    [authState.token, send]
  );

  return { findAll, findOne, create, update };
};

export { useShipmentOrder };
